/**
 * AetherLite Subscriptions — checkout MercadoPago + estado de suscripción.
 *
 * Endpoints backend:
 *   POST /aetherlite/subscriptions/checkout  → init_point para redirect
 *   GET  /aetherlite/subscriptions/me        → estado actual
 *   POST /aetherlite/subscriptions/cancel    → cancela preapproval
 */
import { apiFetch } from "./client";

export type SubscriptionTier = "solo" | "studio" | "unlimited";
export type SubscriptionMode = "auto" | "manual";

export interface CheckoutResponse {
  init_point: string;
  sandbox_init_point?: string | null;
  external_id: string;
  mode: SubscriptionMode;
  tier: SubscriptionTier;
  amount_cop: number;
}

export interface SubscriptionDisplay {
  status: "none" | "pending" | "active" | "past_due" | "cancelled";
  mode: SubscriptionMode | null;
  tier: string;            // free | solo | studio | unlimited
  tier_label: string;      // "Free" | "Solo" | "Studio" | "Unlimited"
  price_cop_monthly: number;
  renews_at: string | null;
  mp_subscription_id: string | null;
  can_cancel: boolean;
}

/**
 * Crea un checkout MercadoPago. Devuelve `init_point` para redirigir al coach.
 * `mode=auto` = preapproval recurrente. `mode=manual` = preference 1 mes.
 */
export async function createCheckout(
  tier: SubscriptionTier,
  mode: SubscriptionMode,
  couponCode?: string | null,
): Promise<CheckoutResponse> {
  return apiFetch<CheckoutResponse>("/aetherlite/subscriptions/checkout", {
    method: "POST",
    body: JSON.stringify({ tier, mode, coupon_code: couponCode || undefined }),
  });
}

export async function getMySubscription(): Promise<SubscriptionDisplay> {
  return apiFetch<SubscriptionDisplay>("/aetherlite/subscriptions/me");
}

export interface CancelFeedback {
  reason?: string;            // too_expensive | using_other | not_useful | missing_feature | pause_only | tech_issues | other
  competitor_app?: string;
  comment?: string;
  would_return?: boolean;
}

export async function cancelSubscription(
  feedback?: CancelFeedback,
): Promise<{ ok: boolean; status: string }> {
  return apiFetch<{ ok: boolean; status: string }>(
    "/aetherlite/subscriptions/cancel",
    {
      method: "POST",
      body: feedback ? JSON.stringify(feedback) : undefined,
    },
  );
}
